import React, { useEffect, useState } from 'react';
import { API_URL } from '../../config';
import './SynopticPage.css';
import { authFetch } from '../../utils';
import { applyEffects } from '../../helpers/useSynopticElementsEffect';

const Synoptic = ({ synopticId , setSynopticId }) => {
  const [elements, setElements] = useState([]);
  const [scale, setScale] = useState(1);

  useEffect(() => {
    const fetchElements = async () => {
      try {
        const res = await authFetch(`${API_URL}synoptic/${synopticId}`);
        if (!res.ok) throw new Error(`Error HTTP: ${res.status}`);
        const data = await res.json();
        setElements(data);
      } catch (err) {
        console.error("Error al cargar el sinóptico:", err);
      }
    };
    fetchElements();
    const interval = setInterval(fetchElements, 10000);
    return () => clearInterval(interval);
  }, [synopticId]);

  useEffect(() => {
    const handleResize = () => {
      const baseWidth = 1750;
      const currentWidth = window.innerWidth;
      setScale(currentWidth / baseWidth);
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div style={{ width: '100%', overflow: 'auto' }}>
      <div
        style={{
          position: 'relative',
          width: 1400,
          height: 1000,
          transform: `scale(${scale})`,
          transformOrigin: 'top left',
          backgroundColor: 'white',
        }}
      >
        {elements.map(el => {
          const e = applyEffects(el); // ← 🔥 aplicar efectos aquí

          const commonStyle = {
            position: 'absolute',
            top: e.top,
            left: e.left,
            width: e.width,
            height: e.height,
            zIndex: e.zIndex ?? (e.type === 'linkToSynopticRectangle' ? 2 : e.dynamic ? 1 : 0),
            ...(e.style || {})
          };

          if (e.type === 'image') {
            return (
              <img
                key={e.elementId}
                id={`${synopticId}-${e.elementId}`}
                src={`/assets/synoptics/${e.src}`}
                alt={e.elementId}
                style={commonStyle}
              />
            );
          }

          if (e.type === 'text' || e.type === 'label') {
            return (
              <div
                key={e.elementId}
                id={`${synopticId}-${e.elementId}`}
                style={{
                  ...commonStyle,
                  color: e.color,
                  fontSize: e.fontSize || 12
                }}
              >
                {e.text}
              </div>
            );
          }

          if (e.type === 'number' ) {
            return (
              <div
                key={e.elementId}
                id={`${synopticId}-${e.elementId}`}
                style={{
                  ...commonStyle,
                  color: e.color,
                  fontSize: 14,
                  fontWeight: 'bold',
                  textAlign: e['text-align'] || 'right'
                }}
              >
                {e.value ?? 0}
              </div>
            );
          }

          if (e.type === 'rectangle') {
            return (
              <div
                key={e.elementId}
                id={`${synopticId}-${e.elementId}`}
                style={{
                  ...commonStyle,
                  backgroundColor: e.color || 'transparent'
                }}
              >
                {e.text}
              </div>
            );
          }

          if (e.type === 'linkToSynopticLabel') {
            return (
              <div
                key={e.elementId}
                id={`${synopticId}-${e.elementId}`}
                className='link-to-synoptic-label'
                onClick={() => setSynopticId(e.link)}
                style={commonStyle}
              >
                {e.text}
              </div>
            );
          }

          if (e.type === 'circle') {
            return (
              <div
                key={e.elementId}
                id={`${synopticId}-${e.elementId}`}
                style={{
                  ...commonStyle,
                  borderRadius: '50%'
                }}
              />
            );
          }

          if (e.type === 'connectionTime') {
            return (
              <div
                key={e.elementId}
                id={`${synopticId}-${e.elementId}`}
                style={{
                  ...commonStyle,
                  color: e.isOld ? 'red' : e.color,
                  fontSize: e.fontSize || 12,
                  textAlign: e['text-align'] || 'right'
                }}
              >
                {e.text ?? '00:00:00'}
              </div>
            );
          }

          if (e.type === 'rssi') {
            const src = e.value >= 17 ? 'cobertura_5.png' :
                        e.value >= 12 ? 'cobertura_4.png' :
                        e.value >= 10 ? 'cobertura_3.png' :
                        e.value >= 7  ? 'cobertura_2.png' : 'cobertura_0.png';
            return (
              <>
              <div
                key={`${e.elementId}-number`}
                id={`${synopticId}-${e.elementId}-number`}
                style={{
                  ...commonStyle,
                  top: e.top + 20,
                  fontSize: 12,
                }}
              >
                <span>RSSI:</span><span>{e.value}</span>
              </div>
              <img
                alt="rssi"
                key={`${e.elementId}-img`}
                id={`${synopticId}-${e.elementId}-img`}
                style={{
                  ...commonStyle,
                }}
                src={`/assets/synoptics/${src}`}
              />
              </>
            );
          }

          if (e.type === 'linkToSynopticRectangle') {
            return (
              <div
                key={e.elementId}
                id={`${synopticId}-${e.elementId}`}
                className='link-to-synoptic-rectangle'
                onClick={() => setSynopticId(e.link)}
                style={commonStyle}
              />
            );
          }

          return null;
        })}
      </div>
    </div>
  );
};

export default Synoptic;
